import { useQuery } from '@tanstack/react-query'
import { func, string } from 'prop-types'

export const Recurser = ({ Component, getItems, id, ...restProps }) => {
  const { data: items = [] } = useQuery({
    queryKey: ['recurser', 'getItems', id],
    queryFn: () => getItems(id),
  })

  return (
    <Component id={id} {...restProps}>
      {items.map(({ id: i, ...rest }) => (
        <Recurser key={i} Component={Component} getItems={getItems} id={i} {...rest} />
      ))}
    </Component>
  )
}

Recurser.propTypes = {
  Component: func.isRequired,
  getItems: func.isRequired,
  id: string.isRequired,
}
